import Vue from "vue";
import constants from "@/config/constants";

const consentUrl = (requestId) =>
    `https://${constants.API_SERVICE_HOST}/oauth/consent/${encodeURIComponent(requestId)}`;

// The consent endpoints live on the API host (the OAuth authorization server), not on the
// dashboard backend. The dashboard bearer token is attached by the vue-auth axios driver.
export const OAuthService = {
    getConsent(requestId) {
        return Vue.axios.get(consentUrl(requestId));
    },

    decide(requestId, approve) {
        return Vue.axios.post(consentUrl(requestId), {approve});
    },
};
